import { gql, TypedDocumentNode } from '@apollo/client';

import {
  DeleteOAuthConnectionMutation,
  DeleteOAuthConnectionMutationVariables,
} from '../generated';

export const DELETE_OAUTH_CONNECTION: TypedDocumentNode<
  DeleteOAuthConnectionMutation,
  DeleteOAuthConnectionMutationVariables
> = gql`
  mutation DeleteOAuthConnection($id: ID!) {
    deleteOAuthConnection(id: $id)
  }
`;
